// extracted by mini-css-extract-plugin
export var rightPanelOpenOld = "_f0-0";